"use client";

import { useEffect, useState } from "react";
import { getHomeSlidersApi } from "../services/home.api";
import type { HomeSliderItem } from "../types/home";

export function useHomeSliders(locale: string, regionSlug?: string) {
  const [slides, setSlides] = useState<HomeSliderItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;

    const loadSlides = async () => {
      setLoading(true);

      try {
        const nextSlides = await getHomeSlidersApi(locale, regionSlug);

        if (!ignore) {
          setSlides(nextSlides);
        }
      } catch {
        if (!ignore) {
          setSlides([]);
        }
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    };

    void loadSlides();

    return () => {
      ignore = true;
    };
  }, [locale, regionSlug]);

  return { slides, loading };
}
